import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';

export interface Option {
  value: any;
  label?: string;
}

@Component({
    selector: 'app-select-search-reactive-form',
    templateUrl: './select-search-reactive-form.component.html',
    styleUrls: ['./select-search-reactive-form.component.scss'],
    standalone: false
})
export class SelectSearchReactiveFormComponent implements OnInit, OnChanges {

  @Input()
  label: string;

  @Input()
  model: any;

  @Input()
  disabled = false;

  @Input()
  options: Option[] = [];

  @Input()
  formControlNameValue: string;

  @Input()
  formGroup: FormGroup;

  @Output()
  modelChange: EventEmitter<any> = new EventEmitter<any>();

  constructor() {
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.disabled && this.disabled) {
      this.model = null;
      this.change();
    }
  }

  change() {
    console.log(this.model);
    this.modelChange.emit(this.model);
  }

}
